<template>
  <div class="table-container">
    <el-table
        :data="tableData"
        :max-height="tableHeight"
        border
        stripe
        :span-method="objectSpanMethod"
        :summary-method="getSummaries"
        show-summary
        size="small"
        ref="table"
        :row-style="{ height: rowHeight + 'px' }"
        :cell-style="{padding: cellPadding + 'px'}"
        style="width: 100%"
    >
      <template  v-for="h in tableHeaders">
        <slot :content="h">
          <el-table-column
              header-align="center"
              align="center"
              :key="h.prop"
              :prop="h.prop"
              :label="h.label"
              v-if="h.fixedFlag && h.showTipFlag"
              :fixed="h.fixed"
              :width="h.width"
              show-overflow-tooltip
              draggable="true"
          >
            <template slot="header" slot-scope="{ column }">
              <el-tooltip :content="h.tipContent" placement="top" effect="dark">
                <span class="table-header-wrapper header-label" :id="h.prop">{{ column.label }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="h.valueType == 'money'" :style="{color: h.valueColor}">{{ ToFixed(scope.row[h.prop] || 0, 2) }}</span>
              <span v-else :style="{color: h.valueColor}">{{ scope.row[h.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :key="h.prop"
              :prop="h.prop"
              :label="h.label"
              :width="h.width"
              v-else-if="!h.fixedFlag && h.showTipFlag"
              show-overflow-tooltip
              draggable="true"
          >
            <template slot="header">
              <el-tooltip :content="h.tipContent" placement="top" effect="dark">
                <span class="table-header-wrapper header-label" :id="h.prop">{{ h.label }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="h.valueType == 'money'" :style="{color: h.valueColor}">{{ ToFixed(scope.row[h.prop] || 0, 2) }}</span>
              <span v-else :style="{color: h.valueColor}">{{ scope.row[h.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :key="h.prop"
              :prop="h.prop"
              :label="h.label"
              v-if="h.fixedFlag && !h.showTipFlag"
              :fixed="h.fixed"
              :width="h.width"
              draggable="true"
          >
            <template slot="header" slot-scope="{ column }">
              <el-tooltip :content="h.tipContent" placement="top" effect="dark">
                <span class="table-header-wrapper header-label" :id="h.prop">{{ column.label }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.showTip" placement="top" effect="dark">
                <span v-if="h.valueType == 'money'" :style="{color: h.valueColor}">{{ ToFixed(scope.row[h.prop] || 0, 2) }}</span>
                <span v-else :style="{color: h.valueColor}">{{ scope.row[h.prop] }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :key="h.prop"
              :prop="h.prop"
              :label="h.label"
              :width="h.width"
              v-else-if="!h.fixedFlag && !h.showTipFlag"
              draggable="true"
          >
            <template slot="header">
              <el-tooltip :content="h.tipContent" placement="top" effect="dark">
                <span class="table-header-wrapper header-label" :id="h.prop">{{ h.label }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.showTip" placement="top" effect="dark">
                <span v-if="h.valueType == 'money'" :style="{color: h.valueColor}">{{ ToFixed(scope.row[h.prop] || 0, 2) }}</span>
                <span v-else :style="{color: h.valueColor}">{{ scope.row[h.prop] }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </slot>
      </template>
      <el-table-column
          header-align="center"
          align="center"
          prop="cz"
          label="操作"
          width="80"
          fixed="right"
          key="cz"
          show-overflow-tooltip
      >
        <template slot="header">
          <el-tooltip content="操作" placement="top" effect="dark">
            <span class="table-header-wrapper">操作</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div class="flex flex-center" v-if="showRecount && scope.row.orderSourceType ==='线下'">
            <el-button size="small" type="text" @click="recount(scope.row)"
            >重新计算</el-button
            >
          </div>
          <div class="flex flex-center" v-if="showViewDetail">
            <el-button size="small" type="text" @click="viewDetail(scope.row)"
            >查看详情</el-button
            >
          </div>
        </template>        
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ToFixed } from "@/utils/utils";
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    rowHeight: {
      type: [String, Number],
      default: "40"
    },
    cellPadding: {
      type: [String, Number],
      default: "0"
    },
    mergeLabelList: {
      type: Array,
      default: () => []
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    showRecount: {
      type: Boolean,
      default: false
    },
    showViewDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ToFixed,
      tableHeight: 500,
      sums: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setHeight();
    })

  },
  methods: {
    /**
     * @author Wujy
     * @date 2020/11/10
     * @Description: 设置table的固定滚筒条
     */
    setHeight() {
      const offsetTop = window.innerHeight - this.$refs.table.$el.offsetTop - 210
      this.$nextTick(() => {
        this.tableHeight = offsetTop;
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeLabelList.indexOf(column.label) > -1) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    },
    getSummaries(param) {
      let sums = [];
      if (this.isArray(this.$parent.$parent.$options.parent.sums) && this.$parent.$parent.$options.parent.sums.length > 0) {
        return this.$parent.$parent.$options.parent.sums;
      }

      if (Object.keys(this.$parent.$parent.$options.parent.summartResult).length === 0) {
        return this.$parent.$parent.$options.parent.sums;
      }

      this.$emit("getSummaries", param, val => { sums = val })
      this.updatedSummary();
      console.log("sums", sums);
      return sums;
    },
    updatedSummary() {
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
        this.footerTr = this.$refs.table.$el.querySelector('.el-table__footer-wrapper tr').children;
        const nodeList = this.footerTr;
        for (let i = 0; i < nodeList.length; i++ ){
          if (nodeList[i].children[0]) {
            if (Number(nodeList[i].children[0].textContent)) {
              nodeList[i].children[0].setAttribute('title', nodeList[i].children[0].textContent)
            }
            this.$nextTick(() => {
              if (this.tableHeaders[i]) {
                if (this.tableHeaders[i].valueColor) {
                  console.log("this.tableHeaders[i]", this.tableHeaders[i])
                  nodeList[i].children[0].setAttribute('style', `color:${this.tableHeaders[i].valueColor}` );
                }
              }
            })

          }
        }
      })
    },
    recount(row) {
      this.$emit("recount",row);
    },
    viewDetail(row) {
      console.log("子组件:",row);
      this.$emit("viewDetail",row);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
  }
}
</script>

<style lang="scss" scoped>
.table-header-wrapper {
  white-space: nowrap;
  text-overflow:ellipsis;
}
</style>